module.exports = __webpack_public_path__ + "img/barrier-beach.c14f579.jpg";